import $ from "jquery";
import placesAutoComplete from "google/places-auto-complete";
import mixpanel from "common/mixpanel";
import pageData from "common/page-data";
import { googleTagManagerTrackFunnelStart } from "common/google-tag-manager";

// Set up Google autocomplete in the search modals
placesAutoComplete.initializeCityState(
  ".js-insurance-referral-profile-search-form-city-state",
  null,
  pageData.get("currentCountry")
);

$(".js-insurance-referral-profile-search-form").submit(() => {
  mixpanel.track("Campaign.Start", pageData.get("mixpanelData"));

  googleTagManagerTrackFunnelStart();
});
